import {
  VehicleCardWrapper,
  VehicleCardsContainerWrapper,
} from './VehicleCardsContainer.styles';
import { type VehicleCardProps } from '../VehicleCard/VehicleCard';
import VehicleCardsCarousel from '../VehicleCardsCarousel/VehicleCardsCarousel';
import VehicleCard from '../VehicleCard/VehicleCard';
import { isMobile } from '@/modules/utils/breakpoints';
import useResizeResponsive from '@/hooks/useResizeResponsive';

interface VehicleCardsContainerProps {
  vehicles: VehicleCardProps[];
  activeSlideIndex: number;
  collapsed?: boolean;
  onSlideChange?: (activeSlideIndex: number) => void;
  resetSlides?: boolean;
}

export const getSlideOffsetY = (vehicles: VehicleCardProps[]) => {
  const hasStock = vehicles.find(({ stockDescription }) => !!stockDescription);
  return hasStock ? 'static250' : 'static0';
};

const VehicleCardsContainer = (props: VehicleCardsContainerProps) => {
  const { vehicles, collapsed } = props;
  const isMobileWidth = useResizeResponsive(isMobile);
  const showCarousel = vehicles.length > 2 && isMobileWidth;

  const slideOffsetY = getSlideOffsetY(vehicles);

  return showCarousel ? (
    <VehicleCardsCarousel {...props} />
  ) : (
    <VehicleCardsContainerWrapper>
      {vehicles.map((vehicle, i) => (
        <VehicleCardWrapper slideOffsetY={slideOffsetY} key={vehicle.title}>
          <VehicleCard
            {...vehicle}
            key={`${vehicle.title}${i}`}
            collapsed={collapsed}
          />
        </VehicleCardWrapper>
      ))}
    </VehicleCardsContainerWrapper>
  );
};

export default VehicleCardsContainer;
